export const countries = [
    {
        value: 'US',
        label: 'USA',
        flag: '🇺🇸 ',
    },
    {
        value: 'CA',
        label: 'Canada',
        flag: '🇨🇦 ',
    },
];
